import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SoTrackModel } from './so-track.model';


export class SoTrackResponseModel extends GlobalResponseObject {
    data?: SoTrackModel;
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: SoTrackModel){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

